import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const downloadSampleExcel = async () => {
	const workbook = new ExcelJS.Workbook();
	const worksheet = workbook.addWorksheet('Customers');

	// Define columns with proper headers
	worksheet.columns = [
		{ header: 'Customer Name *', key: 'customerName', width: 20 },
		{ header: 'Display Name', key: 'displayName', width: 20 },
		{ header: 'Mobile *', key: 'mobile', width: 15 },
		{ header: 'Email', key: 'email', width: 25 },
		{ header: 'Gender *', key: 'gender', width: 12 },
		{ header: 'Date of Birth * (DD-MM-YYYY)', key: 'dob', width: 25 },
		{ header: 'Age *', key: 'age', width: 10 },
		{ header: 'Height (CM) *', key: 'height', width: 15 },
		{ header: 'Weight (Kgs) *', key: 'weight', width: 15 },
		{ header: 'Occupation', key: 'occupation', width: 18 },
		{ header: 'Address', key: 'address', width: 35 },
		{ header: 'Aadhaar Number', key: 'aadhaarNo', width: 18 },
		{ header: 'On-Boarded By (Coach ID) *', key: 'onBoardedBy', width: 30 },
		{ header: 'Referred By (Customer ID)', key: 'referredBy', width: 28 },
		{ header: 'Service ID *', key: 'serviceId', width: 30 },
		{ header: 'Membership ID *', key: 'membershipId', width: 30 },
		{ header: 'Amount *', key: 'amount', width: 12 },
		{ header: 'Paid *', key: 'paid', width: 12 },
		{ header: 'Balance (Auto)', key: 'balance', width: 15 },
		{ header: 'Joining Date * (DD-MM-YYYY)', key: 'joiningDate', width: 25 },
		{ header: 'Paid On * (DD-MM-YYYY)', key: 'paidOn', width: 25 },
		{ header: 'Next Bill Date * (DD-MM-YYYY)', key: 'nextBillDate', width: 25 },
		{ header: 'Payment Method * (cash/upi)', key: 'paymentMethod', width: 25 },
		{ header: 'UPI Transaction ID', key: 'upiTransactionId', width: 25 },
		{ header: 'Remarks', key: 'remarks', width: 30 },
	];

	// Style header row
	worksheet.getRow(1).font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
	worksheet.getRow(1).fill = {
		type: 'pattern',
		pattern: 'solid',
		fgColor: { argb: 'FF4472C4' },
	};
	worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
	worksheet.getRow(1).height = 30;

	// Add sample data row
	worksheet.addRow({
		customerName: 'John Doe',
		displayName: 'Johnny',
		mobile: '9876543210',
		email: 'john@example.com',
		gender: 'male',
		dob: '15-01-1990',
		age: 35,
		height: 175,
		weight: 70,
		occupation: 'Engineer',
		address: '123 Main Street, City',
		aadhaarNo: '123456789012',
		onBoardedBy: 'COACH001',
		referredBy: '',
		serviceId: 'SERVICE001',
		membershipId: 'MEMBER001',
		amount: 5000,
		paid: 5000,
		balance: 0,
		joiningDate: '01-11-2025',
		paidOn: '01-11-2025',
		nextBillDate: '01-12-2025',
		paymentMethod: 'upi',
		upiTransactionId: 'UPI123456789',
		remarks: 'Sample customer data',
	});

	// Add Instructions Sheet
	const instructionsSheet = workbook.addWorksheet('Instructions');
	instructionsSheet.columns = [
		{ header: 'Instructions', key: 'instructions', width: 100 },
	];

	instructionsSheet.getRow(1).font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
	instructionsSheet.getRow(1).fill = {
		type: 'pattern',
		pattern: 'solid',
		fgColor: { argb: 'FF28A745' },
	};
	instructionsSheet.getRow(1).height = 25;

	const instructions = [
		'',
		'📋 HOW TO USE THIS TEMPLATE:',
		'',
		'1. Fill in customer data in the "Customers" sheet',
		'2. Fields marked with * are REQUIRED',
		'3. Follow the format specified in column headers',
		'4. Date format must be DD-MM-YYYY (e.g., 01-11-2025)',
		'5. Gender must be either "male" or "female" (lowercase)',
		'6. Mobile number must be exactly 10 digits',
		'7. Payment method must be either "cash" or "upi" (lowercase)',
		'8. If payment method is "upi", UPI Transaction ID becomes mandatory',
		'9. Balance will be auto-calculated (Amount - Paid)',
		'10. Age should match with Date of Birth (tolerance: 1 year)',
		'',
		'⚠️ IMPORTANT NOTES:',
		'',
		'• Delete the sample row (Row 2) before uploading your actual data',
		'• Do not modify the header row (Row 1)',
		'• Ensure Coach ID, Service ID, and Membership ID exist in the system',
		'• Height should be in centimeters (50-300 CM)',
		'• Weight should be in kilograms (20-300 Kgs)',
		'• Age must be between 1 and 120 years',
		'• All dates should be in DD-MM-YYYY format',
		'',
		'✅ VALIDATION RULES:',
		'',
		'• Customer Name: Minimum 2 characters',
		'• Mobile: Exactly 10 digits',
		'• Email: Valid email format (if provided)',
		'• Aadhaar: Exactly 12 digits (if provided)',
		'• Amount and Paid: Must be 0 or greater',
		'',
		'💡 TIPS:',
		'',
		'• Start with a small batch to test the upload process',
		'• Fix validation errors one row at a time',
		'• Use the error messages to identify and correct issues',
		'• Keep a backup of your original data',
	];

	instructions.forEach((instruction, index) => {
		const row = instructionsSheet.addRow({ instructions: instruction });
		if (instruction.includes('📋') || instruction.includes('⚠️') || instruction.includes('✅') || instruction.includes('💡')) {
			row.font = { bold: true, size: 12, color: { argb: 'FF000000' } };
		}
	});

	// Generate and download
	const buffer = await workbook.xlsx.writeBuffer();
	const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	saveAs(blob, 'Customer_Bulk_Upload_Template.xlsx');
};
